import importer from 'common/importer'
//const { mulesoftDonorReq: req } = importer('APIs', null)
const { deloitReq: req } = importer('APIs', null)
const Config = importer('Config')

let CORE_SCHEDULER_BASIC_AUTH;
if (Config.PLATFORM_TYPE != 'mobile') {
  CORE_SCHEDULER_BASIC_AUTH = WEB_SCHEDULER_BASIC_AUTH;
}

/**
 *
 * @param {Object}  donor REQUIRED
 * @param {Object}  donor.donorDetails REQUIRED
 *
 * @param {String}  donor.donorDetails.donorId,
 * @param {String}  donor.donorDetails.suffix,
 * @param {String}  donor.donorDetails.firstName,
 * @param {String}  donor.donorDetails.middleName,
 * @param {String}  donor.donorDetails.lastName,
 * @param {String}  donor.donorDetails.birthDate,
 * @param {String}  donor.donorDetails.language,
 * @param {String}  donor.donorDetails.gender,
 * @param {String}  donor.donorDetails.phoneNumber,
 * @param {String}  donor.donorDetails.email,
 * @param {String}  donor.donorDetails.phoneType,
 * @param {String}  donor.donorDetails.addressLine1,
 * @param {String}  donor.donorDetails.addressLine2,
 * @param {String}  donor.donorDetails.city,
 * @param {String}  donor.donorDetails.state,
 * @param {String}  donor.donorDetails.country,
 * @param {String}  donor.donorDetails.zipCode,
 * @param {String}  donor.donorDetails.donationCenter,
 * @param {String}  donor.donorDetails.donorLeadSource,
 * @param {Boolean} donor.donorDetails.isMobileTermsAccepted,
 * @param {Boolean} donor.donorDetails.isSmsOptIn,
 * @param {Boolean} donor.donorDetails.isEmailReminderOptIn,
 * @param {Boolean} donor.donorDetails.isSmsReminderOptIn,
 * @param {Boolean} donor.donorDetails.isEmailOptIn
 *
 * @param {String}  donor.loginId
 * @param {String}  donor.password
 * @param {String}  donor.autoVerify
 * @param {String}  donor.salesforceId
*  @param {String}  donor.personContactId
 * @param {String}  donor.url
 *
 * @param {Object}  headers OPTIONAL
 * @param {String}  headers.client_secret
 * @param {String}  headers.client_id
 */
const main = (
  donor,
  headers = {
    Authorization: `Basic ${Config.SCHEDULER_BASIC_AUTH || CORE_SCHEDULER_BASIC_AUTH}`
  }
) => {
  const data = donor
  const config = {
    headers: {
      ...headers
    }
  }

  return req.post('/donors/register-profile', data, config)
}

export default main
